module.exports = __webpack_public_path__ + "static/media/p2_face.e869dbc5.png";